import React, {
    Component,
  } from 'react';
  
  class SocialButtons extends Component {
    render() {
      const { urls } = this.props;
      return (
        <div id="centerDiv">
          <ul className="centerUL">
            {(urls.facebook !==undefined)?
              <li>
              <a href={urls.facebook} >
                <img src={require(`../../img/Facebook_Color.png`)} alt="facebook" />
              </a></li>:null}
              {(urls.twitter !==undefined)?
              <li>
                <a href={urls.twitter} >
                <img src={require(`../../img/Twitter_Color.png`)} alt="twitter" />
              </a></li>:null}
              {(urls.instagram !==undefined)?
              <li>
                <a href={urls.instagram} >
                <img src={require(`../../img/Instagram_Color.png`)} alt="instagram" />
              </a></li>:null}
              {(urls.youtube !==undefined)?
              <li>
                <a href={urls.youtube} >
                <img src={require(`../../img/Youtube_Color.png`)} alt="youtube" />
              </a></li>:null}
              {(urls.googlePlus !==undefined)?
              <li>
                <a href={urls.googlePlus} >
                <img src={require(`../../img/Googleplus_Color.png`)} alt="googlePlus" />
              </a></li>:null}
              {(urls.pinterest !==undefined)?
              <li>
                <a href={urls.pinterest} >
                <img src={require(`../../img/Pinterest_Color.png`)} alt="pinterest" />
              </a></li>:null}
          </ul>
        </div>
      );
    }
  }
  
  export default SocialButtons;


// WEBPACK FOOTER //
// ./src/components/Chefs/SocialButtons.js